export const title = 'Escanea un cupón';
export const subTitle = '';
export const body = 'Si un/a cliente tiene un cupón, te debe mostrar su QR para que lo puedas'
+ ' ver y marcar como usado';
